AOS.init({
  offset: 200,
  duration: 800,
  easing: "ease-out",
  delay: 100,
  once: true,
});